import { JobClass } from '../Job'

export const JOB_CLASSES_THAT_TRIGGER_MAINTENANCE_REMINDER_CAMPAIGN = [
  JobClass.INSTALL,
  JobClass.SERVICE,
  JobClass.MAINTENANCE,
]

type MaintenanceReminderEmailTemplateParameters = {
  bodyContent: string
  customerName: string
  signOff: string
}

export const generateMaintenanceReminderEmailContent = (params: MaintenanceReminderEmailTemplateParameters) => {
  return `
    <p>Hello ${params.customerName},</p>
    ${params.bodyContent}
    <p>Warm regards,</p>
    <p>${params.signOff}</p>
  `
}

export const DEFAULT_MAINTENANCE_REMINDER_CUSTOM_EMAIL_CONTENT =
  `<p>As part of our commitment to ensuring your comfort and the longevity of your system, we recommend scheduling a maintenance visit or tune-up. Regular maintenance helps prevent unexpected breakdowns, improves system efficiency, and extends the life of your equipment.</p>` +
  `<p><u>Why Schedule Now?</u> Avoid the rush and ensure your system is prepared for the upcoming season. Our expert technicians will thoroughly inspect your system, perform necessary adjustments, and replace any worn components.</p>` +
  `<p>To schedule your maintenance visit, simply reply contact our support team at the information provided below. We're here to help ensure your comfort and satisfaction.</p>`

export const DEFAULT_MAINTENANCE_PLAN_VISIT_REMINDER_EMAIL_BODY = `<p>Dear {{{ customerName }}},</p>
<p>It's time to schedule your upcoming {{{ visitDisplayName }}} to ensure your system continues to operate smoothly.</p>
<p>To book your appointment, call us at {{{ contactPhoneNumber }}} or pick a date and time from <a href="{{{ shortLink }}}">{{{ shortLink }}}</a>.</p>
<p>Thank you for choosing us to keep your home comfortable and energy-efficient.</p>
<p>Warm regards,</p>
<p>{{{ companyName }}}</p>`

export const DEFAULT_MAINTENANCE_PLAN_VISIT_REMINDER_EMAIL_SUBJECT = `Schedule your upcoming {{{ visitDisplayName }}}!`

export const DEFAULT_MAINTENANCE_PLAN_VISIT_REMINDER_SMS_TEMPLATE = `Hi {{{ customerName }}}, it's time to schedule your {{{ visitDisplayName }}}.
Book now: {{{ shortLink }}} or call us at {{{ contactPhoneNumber }}}.`
